export enum AuthNextStepEnum {
  RESET_PASSWORD = 'RESET_PASSWORD',
  MFA = 'MFA',
  ADD_SMS_MFA = 'ADD_SMS_MFA',
}
